[
  { "title": "Team experience", "value": "20", "unit": "Years" },
  { "title": "Stocks analysed", "value": "1098", "unit": " /s" },
  { "title": "Quant parameters", "value": "3240", "unit": " /s" },
  { "title": "Throughput", "value": "3.21", "unit": " Gb" },
  { "title": "Order execution", "value": "<100", "unit": " ms" },
  { "title": "Data latency", "value": "<5", "unit": " ms" }
]
